'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.2.10';
//# sourceMappingURL=Version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Version.js
// module id = 775
// module chunks = 168707334958949